import { useMemo } from 'react';
import { TicketsPage } from '@/components/tickets/TicketsPage';
import { makeTicketApi } from '@/shared/api/ticketApi';

// Agent: opens tickets to their business admin (internal) or to KaliAI support
// (platform), and sees the tickets they opened.
export function Tickets() {
  const api = useMemo(() => makeTicketApi('agent'), []);
  return (
    <TicketsPage
      api={api}
      title="הפניות שלי"
      canOpen={[
        { value: 'internal', label: 'מנהל העסק' },
        { value: 'platform', label: 'תמיכת KaliAI' },
      ]}
    />
  );
}
